import React, { Fragment } from 'react';
import {
  shape,
  string,
  bool,
  number,
  arrayOf
} from 'prop-types';
import { CheckNearByStore } from './CheckNearByStore';
import { InventoryWarning } from './InventoryWarning';
import { FULFILLMENT_METHODS } from '../../constants';
import { formatDate } from '../../helper/utils';

const DefaultBoSSDetails = ({
  fulfillment,
  itemId,
  backordered,
  backorderedShipDate,
  isShipToHomeEligible,
  bopisLocaltion,
  bosssDominant,
  quantity
}) => {
  const bossLocation = (fulfillment?.locations || []).find((location) => location.type === 'online');
  const formattedStartDate = formatDate(fulfillment?.deliveryDates?.startDate);
  const formattedEndDate = formatDate(fulfillment?.deliveryDates?.endDate);

  return (
    <>
      {backordered && !formattedStartDate && (
        <div className="alert-inline alert-inline--warning inventory--warning">
          <div>
            <span>This item is</span>
            <span className="u__bold">&nbsp;backordered,&nbsp;</span>
            <span>but will be restocked soon.&nbsp;</span>
            <span>{'We won\'t charge you until it ships.'}</span>
          </div>
        </div>
      )}
      {backordered && formattedStartDate && (
        <div className="alert-inline alert-inline--warning inventory--warning">
          <div>
            <span>This product is currently</span>
            <span className="u__bold">&nbsp;backordered.&nbsp;</span>
            <span>{'We won\'t charge you until it ships.'}</span>
          </div>
        </div>
      )}
      {bosssDominant && bopisLocaltion && (
        <div className="alert-inline alert-inline--warning inventory--warning">
          <div>
            <span className="u__bold">{bopisLocaltion?.storeName}&nbsp;</span>
            <span>only has</span>
            <span className="u__bold">&nbsp;{bopisLocaltion?.inventory?.quantity}&nbsp;</span>
            <span>in stock. </span>
          </div>
        </div>
      )}
      {bosssDominant && !bossLocation?.inventory?.quantity && (
        <div>
          <span>{'We\'ll ship the quantity you need to '}</span>
          <span className="u__bold">{bossLocation?.storeName}</span>
          <span> for</span>
          <span> free pickup </span>
          <span className="u__bold">{formattedStartDate}</span>
          {formattedEndDate && (
            <span className="u__bold">{` - ${formattedEndDate}`}</span>
          )}
        </div>
      )}
      {!bosssDominant && !bossLocation?.inventory?.quantity && (
        <div>
          <span>{'We\'ll send it to '}</span>
          <span className="u__bold">{bossLocation?.storeName}</span>
          <span> for</span>
          <span className="u__text--success"> free pickup </span>
        </div>
      )}
      {(!backordered || bosssDominant) && !!bossLocation?.inventory?.quantity && (
        <div>
          <span>{'We\'ll send up to '}</span>
          <span className="u__bold u__text--success">{ bossLocation?.inventory?.quantity }</span>
          <span> to&nbsp;</span>
          <span className="u__bold">{bossLocation?.storeName}</span>
          <span> for</span>
          <span className="u__text--success"> free pickup </span>
        </div>
      )}
      {bossLocation?.curbsidePickupFlag && (
        <div className="u__text--success"> Curbside pickup available.</div>
      )}
      <div className="fulfillment__sub-title">
        <CheckNearByStore
          itemId={itemId}
          isShipToHomeEligible={isShipToHomeEligible}
        >
          Change Store
        </CheckNearByStore>
      </div>
      {!!bossLocation?.inventory?.quantity && bossLocation?.inventory?.quantity < quantity && (
        <InventoryWarning method={FULFILLMENT_METHODS.STORE} location={bossLocation} />
      )}
    </>
  );
};

DefaultBoSSDetails.propTypes = {
  itemId: string.isRequired,
  backorderedShipDate: string,
  quantity: number,
  isShipToHomeEligible: bool,
  backordered: bool,
  bosssDominant: bool,
  bopisLocaltion: shape({
    isAnchor: bool,
    inventory: shape({
      quantity: number,
      isInStock: bool,
      isLimitedQuantity: bool,
      isBackordered: bool
    })
  }),
  fulfillment: shape({
    type: string,
    locations: arrayOf(shape({
      isAnchor: bool,
      inventory: shape({
        quantity: number,
        isInStock: bool,
        isLimitedQuantity: bool,
        isBackordered: bool
      })
    }))
  }).isRequired
};

DefaultBoSSDetails.defaultProps = {
  quantity: 1,
  isShipToHomeEligible: false,
  backorderedShipDate: '',
  bopisLocaltion: null,
  backordered: false,
  bosssDominant: false

};

export { DefaultBoSSDetails };
